import { Control, FieldErrors, UseFormWatch } from 'react-hook-form'
import { z } from 'zod'
import { useTranslation } from 'react-i18next'
import { ResourceSchema } from '../validation'
import { InputField } from '../../../components'

interface ResourceFormFieldsProps {
  control: Control<z.infer<typeof ResourceSchema>>
  errors: FieldErrors<z.infer<typeof ResourceSchema>>
  watch: UseFormWatch<z.infer<typeof ResourceSchema>>
  isFromEditSheet?: boolean
}

const ResourceFormFields = ({
  control,
  errors,
  watch,
  isFromEditSheet = false,
}: ResourceFormFieldsProps) => {
  const { t } = useTranslation()

  return (
    <InputField
      name="name"
      label={t(isFromEditSheet ? 'sentences.resourceName' : 'sentences.newResourceName')}
      control={control}
      error={errors.name}
      required={watch('name') === ''}
      placeholder={t('sentences.newResourceNamePlaceholder')}
      hintText="sentences.newResourceNameHint"
    />
  )
}
export default ResourceFormFields
